import { combineReducers } from 'redux';

import {
    LOGIN_FAILED,
    LOGIN_SUCCESS,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    REFRESH_AT_FAILURE,
    UPDATE_USER_FAILURE,
    REFRESH_AT_SUCCESS,
    USER_CLEAR_MESSAGE,
    GET_ALL_USERS_SUCCESS,
    LOGOUT_USER_SUCCESS,
    LOGOUT_USER_FAILURE,
    LOGIN_REQUEST,
    CREATE_USER_REQUEST,
    FETCH_MEMBERSHIP_SUCCESS,
    UPDATE_MEMBERSHIP_SUCCESS,
    UPDATE_MEMBERSHIP_FAILURE,
    DELETE_USER_SUCCESS,
} from '../actionTypes';

function byId(state = {}, action) {
    if (!action) return state;

    switch (action.type) {
        case LOGIN_SUCCESS: {
            const { user } = action.payload;
            return { [user.id]: user };
        }

        case CREATE_USER_SUCCESS: {
            const { user } = action.payload;
            return { [user.id]: user };
        }

        case REFRESH_AT_SUCCESS:
        case UPDATE_USER_SUCCESS: {
            const { id, ...rest } = action.payload.user;
            const user = { ...state[id], ...rest };
            return { ...state, [id]: user };
        }

        case GET_ALL_USERS_SUCCESS: {
            const nextState = {};
            action.payload.forEach((user) => {
                const { id, ...rest } = user;
                const oldUser = state[id];
                nextState[id] = { id, ...oldUser, ...rest };
            });
            return nextState;
        }

        case FETCH_MEMBERSHIP_SUCCESS: {
            const { id, membership } = action.payload;
            const { membership: oldMembership, ...rest } = state[id];
            const updatedUser = {
                ...rest,
                membership: { ...oldMembership, ...membership },
            };
            return { ...state, [id]: updatedUser };
        }

        case DELETE_USER_SUCCESS: {
            const { id } = action.payload;
            const nextState = { ...state };
            delete nextState[id];
            return nextState;
        }

        default:
            return state;
    }
}

function authUser(state = null, action) {
    if (!action) return state;

    switch (action.type) {
        case LOGIN_SUCCESS: {
            const { user, token, provider, expiresAt } = action.payload;
            return { ...state, token, expiresAt, provider, id: user.id };
        }

        case REFRESH_AT_SUCCESS: {
            const { token, expiresAt } = action.payload;
            return { ...state, token, expiresAt };
        }

        case CREATE_USER_SUCCESS: {
            const { token, expiresAt, user } = action.payload;
            return { ...state, token, expiresAt, id: user.id };
        }

        case LOGOUT_USER_FAILURE:
        case LOGOUT_USER_SUCCESS: {
            return null;
        }

        case REFRESH_AT_FAILURE: {
            return null;
        }

        default:
            return state;
    }
}

function successMessage(state = '', action) {
    if (!action) return state;

    switch (action.type) {
        case UPDATE_USER_SUCCESS:
        case UPDATE_MEMBERSHIP_SUCCESS:
            return action.payload.message;

        case UPDATE_USER_REQUEST:
            return '';

        case USER_CLEAR_MESSAGE:
            return '';

        default:
            return state;
    }
}

function errorMessage(state = '', action) {
    if (!action) return state;

    switch (action.type) {
        case LOGIN_FAILED:
        case CREATE_USER_FAILURE:
        case UPDATE_USER_FAILURE:
        case UPDATE_MEMBERSHIP_FAILURE:
            return action.payload.message;

        case UPDATE_USER_REQUEST:
            return '';

        case USER_CLEAR_MESSAGE:
            return '';

        default:
            return state;
    }
}

const isFetching = (state = false, action) => {
    if (!action) return state;

    switch (action.type) {
        case LOGIN_REQUEST:
        case CREATE_USER_REQUEST:
        case UPDATE_USER_REQUEST:
            return true;

        case LOGIN_SUCCESS:
        case LOGIN_FAILED:
        case CREATE_USER_SUCCESS:
        case CREATE_USER_FAILURE:
        case UPDATE_USER_FAILURE:
        case UPDATE_USER_SUCCESS:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    byId,
    authUser,
    isFetching,
    errorMessage,
    successMessage,
});

// Selectors
export const getIsFetching = (state) => state.isFetching;
export const getLoginError = (state) => state.errorMessage;
export const getLoginSuccess = (state) => state.successMessage;
export const getErrorMessage = (state) => state.errorMessage;
export const getSuccessMessage = (state) => state.successMessage;
export const getAuthError = (state) => state.errorMessage;
export const getAuthSuccess = (state) => state.successMessage;
export const getAccessToken = (state) => state.authUser && state.authUser.token;
export const getAuthUser = (state) =>
    state.authUser && state.byId[state.authUser.id];
export const getIsLoggedIn = (state) => state.authUser != null;
export const getAuthInfo = (state) => state.authUser;
export const getAllUsers = (state) => Object.values(state.byId);
